enum HelpSectionPriority {
	MINIMUM = 10,
	LOW = 7,
	MIDDLE = 5,
	HIGH = 3,
	MAXIMUM = 1
}

/**
 * Set help sections to open and give priorities
 * @param _section {String=} - Help section to open as the default. Priority is 10.
 * @constructor
 */
export class HelpSection {
	
	static readonly Priority = HelpSectionPriority;
	
	static openHelp(section?: string) {
		window.open(HelpSection.getHelpLink(section), 'LogBookHelp')
	}
	
	static getHelpLink(section?: string) {
		return `/help/help.html${section ? '#' + section : ''}`;
	}
	
	constructor(private _section: string | undefined) {}
	
	private _priority = HelpSectionPriority.MINIMUM;
	
	/**
	 * Set the current section with a priority. If the priority is lower or equal to the current
	 * priority, the new section is set.
	 * @param section {String=}
	 * @param priority {Number|String=}
	 */
	setSection(section: string | undefined, priority: number | string | HelpSectionPriority = HelpSectionPriority.LOW) {
		if (typeof section !== "string") return;
		priority = typeof priority === 'string' ? parseInt(priority) : priority;
		priority = isNaN(priority) ? 10 : priority;
		
		if (priority <= this._priority) {
			this._priority = priority;
			this._section = section;
		}
		
		return this;
	}
	
	getSection(): string {
		return typeof this._section === 'string' ? this._section : '';
	}
	
	open() {
		HelpSection.openHelp(this.getSection());
	}
}